import * as React from "react";
import { SVGProps, memo } from "react";

const SvgClaimantCertification = (props: SVGProps<SVGSVGElement>) => (
  <svg width={29} height={37} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fill="#FCF4DE" d="M.5 0h28v37H.5z" />

    <rect x={4.5} y={10} width={20} height={2} rx={1} fill="#000" fillOpacity={0.3} />

    <rect x={4.5} y={16} width={20} height={2} rx={1} fill="#000" fillOpacity={0.3} />

    <rect x={4.5} y={22} width={20} height={2} rx={1} fill="#000" fillOpacity={0.3} />

    <path
      fill="#000"
      fillOpacity={0.3}
      d="M4.5 5h2v2h-2zM10.5 5h2v2h-2zM16.5 5h2v2h-2zM22.5 5h2v2h-2z"
    />

    <path stroke="#FF8D4E" d="M20 28.5h4v4h-4z" />
  </svg>
);

const Memo = memo(SvgClaimantCertification);

export default Memo;
